/* JRC "Compatibility & fitting" block (snippets/jrc-compat-fitting.liquid), 2026-09-28
   Everything is rendered by Liquid; this only enhances it.
   1. Placement: wide screens keep the block where Liquid put it (media column,
      under the gallery/spec strip, above Materials + Included). At <= 990px -
      the width at which the theme swaps its media-column accordions for the
      info-column ones - the SAME element moves into the info column above the
      Materials accordion, so there is never a duplicate tree or duplicate ids.
   2. Variant changes: rows and documents carrying data-variants are shown only
      for those variant ids. Listens to the theme's own variantChange event, so
      the variant picker / cart behaviour is untouched.
   3. Shortcut + deep links: a[data-jrc-compat-link] (the "Check compatibility"
      note by the buy button) and #compat-<key> URLs open the relevant row,
      scroll it under the sticky header (CSS scroll-margin-top) and focus it. */
(function () {
  'use strict';
  if (window.customElements && customElements.get('jrc-compat')) return;

  var NARROW = window.matchMedia('(max-width: 990px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function place(el) {
    var product = el.closest('.product');
    if (!product) return;
    var media = product.querySelector('.product__media-wrapper');
    var info = product.querySelector('product-info');
    if (NARROW.matches && info) {
      var firstAccordion = info.querySelector(':scope > .product__accordion');
      if (firstAccordion) {
        if (el.nextElementSibling !== firstAccordion) info.insertBefore(el, firstAccordion);
      } else if (el.parentNode !== info) {
        info.appendChild(el);
      }
    } else if (media) {
      var wrapper = media.querySelector(':scope > .product__accordion-wrapper');
      if (wrapper) {
        if (el.nextElementSibling !== wrapper) media.insertBefore(el, wrapper);
      } else if (el.parentNode !== media) {
        media.appendChild(el);
      }
    }
  }

  function placeAll() {
    Array.prototype.forEach.call(document.querySelectorAll('jrc-compat'), place);
  }

  class JrcCompat extends HTMLElement {
    connectedCallback() {
      // Moving the element (placement above) disconnects and reconnects it;
      // the subscription is dropped on disconnect, so there is only ever one.
      if (this.unsubscribe || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      var self = this;
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var data = event && event.data;
        if (!data || !data.variant) return;
        if (data.sectionId && data.sectionId !== self.dataset.section) return;
        self.applyVariant(data.variant.id);
      });
    }

    disconnectedCallback() {
      if (this.unsubscribe) {
        this.unsubscribe();
        this.unsubscribe = null;
      }
    }

    applyVariant(id) {
      var vid = String(id);
      Array.prototype.forEach.call(this.querySelectorAll('[data-variants]'), function (node) {
        var ids = node.getAttribute('data-variants').split(',');
        if (ids.indexOf(vid) !== -1) {
          node.hidden = false;
        } else {
          node.hidden = true;
          if (node.tagName === 'DETAILS') node.open = false;
        }
      });
      var fallback = this.querySelector('[data-docs-fallback]');
      if (fallback) {
        var anyDoc = Array.prototype.some.call(this.querySelectorAll('.jrc-compat__doc-item'), function (li) {
          return !li.hidden;
        });
        fallback.hidden = anyDoc;
      }
    }

    reveal(key) {
      var target = null;
      if (key) target = this.querySelector('details[data-key="' + key + '"]:not([hidden])');
      if (!target) target = this.querySelector('details[data-shortcut]:not([hidden])');
      if (!target) target = this.querySelector('details:not([hidden])');
      if (!target) return;
      target.open = true;
      // Land just below the header as it will be once scrolled: the sticky
      // header section itself, not --header-height (which also counts the
      // announcement bar that scrolls away).
      var header = document.querySelector('.section-header');
      var offset = 0;
      if (header) {
        var pos = getComputedStyle(header).position;
        if (pos === 'sticky' || pos === 'fixed') offset = header.offsetHeight;
      }
      target.style.scrollMarginTop = offset + 16 + 'px';
      var summary = target.querySelector('summary');
      if (summary) summary.focus({ preventScroll: true });
      target.scrollIntoView({ block: 'start', behavior: REDUCED.matches ? 'auto' : 'smooth' });
    }
  }

  customElements.define('jrc-compat', JrcCompat);

  // Advisory notice "Why?" disclosure (2026-09-30): a button in the row body
  // (never the row summary), so it cannot open/close the row itself.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('.jrc-compat__notice-toggle');
    if (!btn) return;
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    var open = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.setAttribute('aria-label', btn.getAttribute(open ? 'data-label-open' : 'data-label-closed') || '');
    var text = btn.querySelector('.jrc-compat__notice-toggle-text');
    if (text) text.textContent = text.getAttribute(open ? 'data-text-open' : 'data-text-closed');
    panel.hidden = !open;
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[data-jrc-compat-link]');
    if (!link) return;
    var id = (link.getAttribute('href') || '').replace(/^#/, '');
    var block = id && document.getElementById(id);
    if (!block || typeof block.reveal !== 'function') return; // plain anchor fallback
    event.preventDefault();
    block.reveal(link.getAttribute('data-jrc-compat-link'));
  });

  function openFromHash() {
    var m = /^#compat-([\w-]+)$/.exec(window.location.hash || '');
    if (!m) return;
    var block = document.querySelector('jrc-compat');
    if (block && typeof block.reveal === 'function') block.reveal(m[1]);
  }

  placeAll();
  openFromHash();
  (NARROW.addEventListener ? NARROW.addEventListener('change', placeAll) : NARROW.addListener(placeAll));
  window.addEventListener('hashchange', openFromHash);
  document.addEventListener('shopify:section:load', placeAll);
})();
